import React from 'react';
interface SectionHeadingProps {
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  caption?: string;
  cropImage?: boolean;
  cropPosition?: 'center' | 'bottom';
}
export function SectionHeading({
  children,
  imageSrc,
  imageAlt = '',
  caption,
  cropImage = false,
  cropPosition = 'center'
}: SectionHeadingProps) {
  const imageClassName = cropImage ? `h-64 w-full object-cover sm:h-80 ${cropPosition === 'bottom' ? 'object-bottom' : 'object-center'}` : 'h-auto w-full';
  return <>
      <h2 className="mb-4 mt-12 font-display text-[28px] font-bold leading-snug text-ink sm:text-[32px]" data-id="element-334">
        {children}
      </h2>
      {imageSrc && <figure className="mb-8 overflow-hidden rounded-lg border border-ink/10 bg-white shadow-sm" data-id="element-335">
          <img src={imageSrc} alt={imageAlt} className={imageClassName} data-id="element-336" />
          {caption && <figcaption className="border-t border-ink/10 px-4 py-3 text-center text-base italic text-ink-soft" data-id="element-337">
              {caption}
            </figcaption>}
        </figure>}
    </>;
}